import * as Yup from "yup";

export const formValidationSchema = () =>
  Yup.object().shape({
    namaJenis: Yup.string().required("Masukan nama jenis anggaran"),
  });
